import DigitalStoreError from './DigitalStoreError'

export default DigitalStoreError



// WEBPACK FOOTER //
// ../src/error/index.js